// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root_3CT9g"};